import React, { Component } from 'react';
import './Page.css';
import './Account.css';

import { API_BASE } from '../config';
import { Link } from 'react-router';

import Button from '../components/Button';
import Input from '../components/Input';
import Notification from '../components/Notification';

class Info extends Component {

  constructor(props) {
    super(props);

    this._getUser = this._getUser.bind(this);

    this.state = {
      notification_text:"",
      user_id:localStorage.getItem('user_id'),
      user:{
        name:"",
        email:""
      },
      welcome_message:this.props.params.welcome || false
    };

  }

  componentDidMount() {

    this._getUser();

  }

  render() {

      return (
        <div>
          <Notification text={this.state.notification_text} />

          <div className='App-signIn Page clearfix'>
          
            <div className="Account">

                <h1>Personal Profile</h1>
                <p><strong>This won't affect any of your stores.</strong> (Except how you sign in.)<br />Update a store's information through the <Link to="/">Manage Stores</Link> section.</p>
                <Input label="Name" name="name" value={this.state.user.name} endpoint="users" id={this.state.user.id} />
                <Input label="Email" name="email" value={this.state.user.email} endpoint="users" id={this.state.user.id} />
                <p>&nbsp;</p>
                <h3>Change Password/Passphrase</h3>
                <Input label="New password/passphrase" name="password" hidable value="" endpoint="users" id={this.state.user.id} />

                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <h3>&times; Close your account</h3>
                <p>Right now, you'll need to <a href="mailto:drew@reallysimplestore.com">email us</a> to close your account. This is only because closing accounts isn't automated in the code. I won't ask any questions or try to convince you to stay!</p>
            </div>
          </div>

        </div>
        
      );
  
  }

  _getUser() {
    var _this = this;

    var request = new Request(`${API_BASE}users/`+_this.state.user_id, {
      method: 'GET', 
      mode: 'cors',
      headers: new Headers({
        'Authorization': localStorage.getItem('token')
      })
    });

    fetch(request).then(function(response) {
      return response.json();
    }).then(function(json) {

      _this.setState({
        user:json
      });

    }).catch(function(ex) {
      console.log('parsing failed', ex);
    });
  }

}

export default Info;



// WEBPACK FOOTER //
// ./src/pages/Info.js